export default __webpack_public_path__ + "static/media/Milestone 10L.d31004ca.svg";